module.exports = "/_next/static/images/img__card-6-desktop-f817f5a727a4e8eaa68c56d20b06da98.png";